<template>
  <div class="box cta">
    <p class="has-text-centered has-text-weight-bold has-text-link">
      <span class="tag is-primary">Nuevo</span> Ya tenemos disponible el
      conector de información para Buk y Talana.
    </p>
  </div>
</template>

<script>
export default { name: "BoxNew" };
</script>

<style lang="sass" scoped></style>
